import React from 'react';
import './CrownedELXR.css';

const CrownedELXR = ({ className = '', style = {}, ...props }) => {
  const containerStyle = {
    display: 'inline-block',
    position: 'relative',
    fontWeight: 'bold',
    lineHeight: '1.2',
    paddingTop: '0.8em',
    fontSize: 'inherit',
    ...style
  };

  const elContainerStyle = {
    position: 'relative',
    display: 'inline-block',
    marginRight: '0.0em'
  };

  const crownStyle = {
    position: 'absolute',
    top: '-0.8em',
    left: 'calc(50% - 5px)',
    transform: 'translateX(-50%)',
    fontSize: '0.7em',
    lineHeight: '1',
    zIndex: 10,
    display: 'block',
    color: '#FFD700',
    WebkitTextFillColor: '#FFD700'
  };

  const letterStyle = {
    fontSize: 'inherit',
    fontWeight: '900',
    background: 'linear-gradient(135deg, #a855f7 0%, #22c55e 100%)',
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    color: 'transparent',
    WebkitTextFillColor: 'transparent',
    display: 'inline-block',
    padding: 0,
    margin: 0,
    lineHeight: 'inherit'
  };

  return (
    <span 
      className={`crowned-elxr ${className}`} 
      style={containerStyle} 
      {...props}
    >
      <span style={elContainerStyle}>
        <span style={crownStyle}>👑</span>
        <span style={letterStyle}>E</span>
        <span style={letterStyle}>L</span>
      </span>
      <span style={letterStyle}>X</span>
      <span style={letterStyle}>R</span>
    </span>
  );
};

export default CrownedELXR; 